<template>
  <div class="home">
    <div class="home-video">
<!--      <img class="video-js" :src="bannerImage"/>-->
      <video
          :src="video1080"
          class="video-js"
          playsinline
          x5-playsinline
          id="video750"
      ></video>
    </div>

    <div class="home-block" style="background-color: #fff;">
      <div class="home-title">公司简介</div>
      <div class="home-subtitle">
        <p>{{introduction.subTitle}}</p>
      </div>
      <div class="home-desc">
<!--        <p>通过建筑机器人、智能工程设备以及新型建筑工业化产品的研发、生产与应用，提升建筑工业化水平。 以BIM数字化技术为基础，建立贯穿建筑全生命周期以及产业链上下游的产业互联网平台。 </p>-->
<!--        <p>引入精益建造理念，打造新型建筑施工组织方式。</p>-->
<!--        <p>助力建筑业转型升级，促进行业高质量可持续发展。</p>-->
          <p v-for="item in introduction.summary" >{{item}}</p>
      </div>
    </div>

    <div class="home-block" style="background-color: #F9F9F9;">
      <div class="home-title">产品及服务</div>
      <div class="home-desc" id="production-desc">
<!--        公司主要提供适用于现浇混凝土、PC装配式建筑各施工环节的建筑机器人与智能设备租售、技术服务。提供模块化别墅、集成卫浴等新型装配式体系产品的销售与服务。 提供BIM全过程咨询服务、BIM软件产品及基础平台的销售与实施服务。-->
      </div>
      <div class="home-product">
        <div class="home-product-item" v-for="(product, index) in products" :key="index"  @click="jump(product.path)">
          <img :src="product.img" alt="" class="home-product-item_pic">
          <div class="home-product-item_text">
            <div class="home-product-item_title">{{product.title}}</div>
            <div class="home-product-item_subtitle">{{product.subtitle}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="home-block" style="background-color: #fff;">
      <div class="home-news">
        <div class="home-news-header">
          <div class="home-news-header_title">公司新闻</div>
          <div class="home-news-header_more" @click="jump('/news')">查看更多</div>
        </div>
        <div class="home-news-content">
          <div class="home-news-item" @click="jump(`/news-detail?id=${item.id}`)" v-for="(item, index) in newsList" :key="index">
            <img  class="home-news-item_pic" :src="item.url" alt="">
            <div class="home-news-item_info">
              <div class="home-news-item_title">{{item.title}}</div>
              <div class="home-news-item_date">{{item.createAt}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-news">
        <div class="home-news-header">
          <div class="home-news-header_title">媒体新闻</div>
          <div class="home-news-header_more" @click="jump('/medias')">查看更多</div>
        </div>
        <div class="home-news-content">
          <div class="home-news-item"  @click="jump(`/media-detail?id=${item.id}`)" v-for="(item,index) in mediaList" :key="index">
            <img  class="home-news-item_pic" :src="item.url" alt="">
            <div class="home-news-item_info">
              <div class="home-news-item_title">{{item.title}}</div>
              <div class="home-news-item_date">{{item.createAt}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Video from 'video.js';
import 'video.js/dist/video-js.css';
import bannerImage from '@/assets/images/home/banner-mobile.jpg';
import video750 from '@/assets/750.mp4';
import video1080 from '@/assets/1080.mp4';
export default {
  name: 'Home',
  data () {
    return {
      bannerImage,
      video750,
      video1080,
      isFullScreen: false,
      production:{},
      products: [
        { img: require('@/assets/images/home/product-1.png'), path: '/robot-list', title: '建筑机器人', subtitle: 'Construction Robot' },
        { img: require('@/assets/images/home/product-2.png'), path: '/digi-tech', title: '数字科技', subtitle: 'Digital Technology' },
        { img: require('@/assets/images/home/product-3.png'), path: '/new-build', title: '新型建筑工业化', subtitle: 'New Building Industrialization' },
        { img: require('@/assets/images/home/product-4.png'), path: '/build', title: '智慧施工', subtitle: 'Smart Construction' },
      ],
      newsList:[],
      mediaList: [],
      introduction:{},
      news: [
        {
          title: '媒体报道',
          path: '/news?type=media',
          list:[
            { img: require('@/assets/images/home/new-4.png'), path: '/media-detail?id=1', title: '科技助力智能建造，建筑业数字化转型提速', date: '2021-03-10' },
            { img: require('@/assets/images/home/new-5.png'), path: '/media-detail?id=2', title: '当机器人能顶“半边天”，智慧工地离我们还有多远？', date: '2021-03-07' },
            { img: require('@/assets/images/home/new-6.png'), path: '/media-detail?id=3', title: '迈向智能建造新时代，博智林建筑机器人核心系统全自主研发……', date: '2021-03-06' },
          ]
        }
      ]
    }
  },
  created() {
   this.initIntroduction();
   this.initProduction();
   this.initNews();
   this.initMedia();
  },
  watch: {
    isFullScreen (val) {
      document.body.style.overflow = val ? 'hidden' : 'auto';
    }
  },
  mounted() {
    this.initVideo();
    //this.testRemoteContents()
  },
  methods: {
      async initBanner() {
        let contents = await this.$get
      },
      async initIntroduction() {
          let contents = await this.$getContents(this.$channels.introduction);
          if (contents.length > 0){
              this.introduction.subTitle = contents[0].subTitle;
              this.introduction.summary = contents[0].summary.split("\n");
          }
          console.log("this.introduction", this.introduction)
      },
      async initProduction() {
          let contents = await this.$getContents(this.$channels.product);
          
          console.log("this.productionCon", contents)
          if (contents.length > 0){
              for (let i=0;i<contents.length;i++){

                  if (contents[i].channelName == this.$channels.product) {
                      console.log("this.flag", contents[i].channelName == this.$channels.product);

                      let productionCon = contents[i].body.replaceAll("src=\"/","src=\""+process.env.VUE_APP_BASE_API+"/");

                      let insertDiv = document.getElementById("production-desc");
                      insertDiv.innerHTML = productionCon;


                      let maxWidth =await insertDiv.clientWidth;
                      console.log("maxWidth",maxWidth);
                      if (insertDiv.getElementsByTagName("video").length > 0) {

                          await Array.from(insertDiv.getElementsByTagName("video")).forEach(item => {


                              let videoWidth = item.clientWidth;
                              console.log("videoWidth",videoWidth);
                              if (videoWidth>maxWidth){
                                  item.style.width = maxWidth+"px";
                              }

                          });
                      }
                      if (insertDiv.getElementsByTagName("img").length > 0) {

                          await Array.from(insertDiv.getElementsByTagName("img")).forEach(item => {



                              let img = new Image();
                              img.src = item.src;
                              img.onerror = ()=>{ console.log("img.onerror",item.src)};
                              img.onload = () =>{
                                  console.log("img.onload",item.src);
                                  let ratio;  // 缩放比例
                                  let width = item.naturalWidth;
                                  let height = item.naturalHeight;

                                  console.log("width",width);
                                  console.log("height",height);

                                  // 检查图片是否超宽
                                  // if (width > maxWidth) {
                                  //计算缩放比例
                                  ratio = maxWidth / width;
                                  height = height * ratio;    // 计算等比例缩放后的高度
                                  item.style.width = maxWidth+"px";
                                  item.style.height  = height+"px";
                                  // }
                                  console.log("item.style.width",item.style.width);
                                  console.log(" item.style.height", item.style.height);
                              };

                              item.style.marginLeft = "0px";
                              item.style.marginRight = "0px";

                          });
                      }
                      break;
                  }
              }
          }
      },
      async initNews() {
          let contents = await this.$getContents(this.$channels.news);
          contents.forEach(
              item => {
                  this.newsList.push({
                      id: item.id,
                      title: item.title,
                      url: process.env.VUE_APP_BASE_API + item.imageUrl,
                      createAt: item.addDate.substring(0, 10),
                      detail: item.body.replaceAll("/upload/images", process.env.VUE_APP_BASE_API + "/upload/images"),
                      from: item.source
                  })
              }
          );

          this.newsList = this.newsList.sort(this.sortUpDate).slice(0,3);
          console.log("this.newsList", this.newsList)
      },
      async initMedia() {
          let contents = await this.$getContents(this.$channels.media);
          contents.forEach(
              item => {
                  this.mediaList.push({
                      id: item.id,
                      title: item.title,
                      url: process.env.VUE_APP_BASE_API + item.imageUrl,
                      createAt: item.addDate.substring(0, 10),
                      detail: item.body.replaceAll("/upload/images", process.env.VUE_APP_BASE_API + "/upload/images"),
                      from: item.source
                  })
              }
          );

          this.mediaList = this.mediaList.sort(this.sortUpDate).slice(0,3);
          console.log("this.mediaList", this.mediaList)
      },
    sortUpDate(pre,next){
      return Date.parse(next.createAt)- Date.parse(pre.createAt) ;
    },
    initVideo () {
      const video750 = document.getElementById('video750');
      Video(video750, {
        controls: true,
        autoplay: "muted",
        preload: "auto",
        loop: true,
        sources: [
          {
            src: video1080,
            type: "video/mp4"
          }
        ]
      }, function onPlayerReady () {
        const that = this;
        document.addEventListener("WeixinJSBridgeReady", function () {
          // 安卓手机部分需要用户手动点击播放
          if (navigator.userAgent.indexOf('Android') > -1) {
            document.addEventListener('click', () => {
              that.play();
            })
          } else {
            that.play();
          }
        }, false)
      });
    },
    jump (path) {
      path && this.$router.push(path);
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  &-video {
    position: relative;
    height: 750px;
    .video-js {
      width: 100vw;
      height: 750px;
    }
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    &-play {
      position: absolute;
      bottom: 5%;
      right: 5%;
      width: 48px;
      height: 48px;
      background: url("~@/assets/images/icon_video_play.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  &-banner {
    position: relative;
    height: 750px;
    background-color: #F9F9F9;
    img {
      width: 100%;
      height: 100%;
    }
    &-info {
      position: absolute;
      top: 50%;
      width: 100%;
      transform: translateY(-50%);
      color: #fff;
      text-align: center;
    }
    &-title {
      font-size: 36px;
      font-weight: 400;
      line-height: 50px;
      margin-bottom: 2px;
    }
    &-subtitle {
      font-size: 18px;
      font-weight: 400;
      line-height: 25px;
    }
  }
  &-block {
    padding: 132px 48px;
  }
  &-title {
    position: relative;
    font-size: 48px;
    font-weight: 500;
    color: #333;
    text-align: center;
    margin-bottom: 32px;
    line-height: 68px;
    &::after {
      content: " ";
      position: absolute;
      width: 72px;
      height: 4px;
      bottom: -4px;
      left: 50%;
      margin-left: -36px;
      background-color: #D8609E;
    }
  }
  &-subtitle {
    line-height: 48px;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    margin-bottom: 24px;
  }
  &-desc {
    line-height: 56px;
    font-size: 28px;
    font-weight: 400;
    color: #666666;
  }
  &-product {
    margin-top: 32px;
    &-item {
      position: relative;
      width: 654px;
      height: 480px;
      &:not(:last-child) {
        margin-bottom: 32px;
      }
      &_pic {
        width: 100%;
        height: 100%;
      }
      &_text {
        position: absolute;
        left: 60px;
        bottom: 60px;
        color: #fff;
      }
      &_title {
        font-size: 48px;
        font-weight: 600;
        line-height: 48px;
        margin-bottom: 23px;
      }
      &_subtitle {
        font-size: 28px;
        font-weight: 400;
        line-height: 28px;
      }
    }
  }
  &-news {
    &-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 42px;
      &_title {
        font-size: 48px;
        font-weight: 500;
        color: #333;

      }
      &_more {
        position: relative;
        font-size: 28px;
        font-weight: 400;
        color: #666666;
        &::after {
          content: " ";
          position: absolute;
          width: 36px;
          height: 36px;
          background: url("~@/assets/images/icon_arrow.png") no-repeat;
          background-size: 100% 100%;
          transform: rotate(270deg);
        }
      }
    }
    &-item {
      display: flex;
      flex-direction: row;
      margin-bottom: 32px;
      &_pic {
        width: 206px;
        height: 154px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &_info {
        flex: 1;
        margin-left: 24px;
      }
      &_title {
        font-size: 28px;
        font-weight: 400;
        line-height: 48px;
        color: #333333;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      &_date {
        font-size: 24px;
        font-weight: 400;
        line-height: 36px;
        color: #979797;
      }
    }
    &:first-child {
      margin-bottom: 132px;
    }
  }
}
.video-model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #333;
  z-index: 99;
  video {
    position: absolute;
    top: 45%;
    transform: translateY(-50%);
    width: 100vw;
  }
  &-close {
      position: absolute;
      bottom: 26%;
      left: 50%;
      width: 48px;
      height: 48px;
      transform: translateX(-50%);
      background: url("~@/assets/images/icon_video_close.png") no-repeat;
      background-size: 100% 100%;
  }
}
</style>
